'use client'

import React from 'react'

import {
  Breadcrumbs,
  Footer,
  Header,
  Main,
  PageWrapper,
} from 'Components/Blocks'
import { AllProjectListSection, WorkHeroSection } from 'Components/Sections'
import { AllProjectsListData } from 'Data/types'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'
import { WORK } from 'Constants/Paths'

type Props = {
  data?: AllProjectsListData
}

// The server page passes a pre-filtered slim list (VISIBLE_PROJECTS) — no
// client re-filter, no store hand-off (the paginator gets its neighbors
// from the case-page server component now).
function WorkPage({ data }: Props) {
  return (
    <PageWrapper>
      <Header />

      <Main>
        <Breadcrumbs
          paths={[{ caption: 'Work', href: WORK }]}
          pt={160}
          px={LANDING_INLINE_PADDINGS}
        />

        <WorkHeroSection pb={17} pt={9} />

        <AllProjectListSection data={data} pb={17} />
      </Main>

      <Footer />
    </PageWrapper>
  )
}

export default WorkPage
